export const CATEGORY_CODES = {
  main: 'MEDS',
};
